// Opt-in: date pickers (FlatpickrDateInput, DateRangeInput).
import FlatpickrController from './flatpickr_controller'

export function register(application) {
  application.register('flatpickr', FlatpickrController)
}
